module.exports = __webpack_public_path__ + "static/img_9856-2c4a48c5b9bdda9b5ea495f83f00ab1c.webp";